import { BaseFeature } from '../../core/base-feature.js';

/**
 * DigitalGraffitiFeature - Draw on the desktop screen remotely
 *
 * Fire-and-forget for all draw commands. Only getState() uses request/response.
 */
export class DigitalGraffitiFeature extends BaseFeature {
    constructor(coreAPI) {
        super(coreAPI);
        this.pendingRequests = new Map();
    }

    static getMetadata() {
        return {
            id: 'digital-graffiti',
            name: 'Digital Graffiti',
            version: 'v1.0',
            capabilities: [
                'show', 'hide',
                'draw_line', 'draw_straight_line', 'draw_circle', 'draw_arrow', 'draw_text',
                'clear', 'undo', 'get_state'
            ],
            dependencies: []
        };
    }

    async initialize() {
        console.log('[DigitalGraffiti] Initialized');
    }

    show() {
        this.sendMessage('show', {});
    }

    hide() {
        this.sendMessage('hide', {});
    }

    drawLine(points, color, thickness) {
        this.sendMessage('draw_line', { points, color, thickness });
    }

    drawStraightLine(x1, y1, x2, y2, color, thickness) {
        this.sendMessage('draw_straight_line', { x1, y1, x2, y2, color, thickness });
    }

    drawCircle(cx, cy, radius, color, thickness) {
        this.sendMessage('draw_circle', { cx, cy, radius, color, thickness });
    }

    drawArrow(x1, y1, x2, y2, color, thickness) {
        this.sendMessage('draw_arrow', { x1, y1, x2, y2, color, thickness });
    }

    drawText(x, y, text, color, fontSize) {
        this.sendMessage('draw_text', { x, y, text, color, fontSize });
    }

    clearAll() {
        this.sendMessage('clear', {});
    }

    undo() {
        this.sendMessage('undo', {});
    }

    getState() {
        return new Promise((resolve, reject) => {
            const messageId = this.sendMessage('get_state', {});
            const timeout = setTimeout(() => {
                this.pendingRequests.delete(messageId);
                reject(new Error('getState timed out'));
            }, 5000);
            this.pendingRequests.set(messageId, { resolve, reject, timeout });
        });
    }

    async handleMessage(message) {
        const { action, payload, requestId } = message;

        if (action === 'get_state' && requestId && this.pendingRequests.has(requestId)) {
            const pending = this.pendingRequests.get(requestId);
            clearTimeout(pending.timeout);
            this.pendingRequests.delete(requestId);
            pending.resolve(payload);
            return;
        }
    }

    async cleanup() {
        for (const [, pending] of this.pendingRequests) {
            clearTimeout(pending.timeout);
            pending.reject(new Error('Feature cleaned up'));
        }
        this.pendingRequests.clear();
    }
}
